import { GET_LEAD_SOURCES } from "../../Actions/ActionConstants";

function leadSourcesReducer(state=null,action){
    switch (action.type) {
        case GET_LEAD_SOURCES:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default leadSourcesReducer